export function primaryWearNoteDestination(wearLogId) {
  return {
    pathname: '/log',
    state: {
      wearLogId,
      noteCaptureWearLogId: wearLogId,
    },
  }
}
